import React from "react";
import { useNavigate } from "react-router-dom";

const SideBarItem = ({ item, isActive }) => {
     const navigate = useNavigate();

  return <div
      onClick={() => navigate(item.link)}
      className={`
        h-[79px] 
        flex flex-col 
        items-center 
        justify-center 
        rounded-[10px] 
        transition-all duration-200
        cursor-pointer

        ${isActive 
          ? "bg-white text-[#910E11] shadow-[0px_0px_6px_0px_#0000000D]" 
          : "hover:bg-[#f9f3f3] hover:shadow-[0px_0px_6px_0px_#0000000D] text-[#787878]"
        }
      `}
    >
      {isActive ? item.activeIcon : item.staticIcon}
      <p>{item.label}</p>
    </div>
};

export default SideBarItem;
